import React, { useRef } from "react";
import Title from "../../../../Universal/Title.component";
import { FieldArray, Form, Formik } from "formik";
import FormInput from "../../../../Universal/FormInput.component";
import DropDownInput from "../../../../Universal/DropDownInput.component";
import InputRowItem from "./InputRowItem.component";
import PlusIconBlue from "../../../../../assets/Icons/Universal/PlusIconWithBlueBack.svg";
import PlusIconYellow from "../../../../../assets/Icons/Universal/PlusWithYellowBack.svg";
import PlusIconGreen from "../../../../../assets/Icons/Universal/PlusIconWithGreenBack.svg";
const AddNewFee = ({
  formType = "yearly",
  outputData,
  formTitle,
  isModal = false,
  data,
}) => {
  const addNewDataFormik = useRef(null);
  return (
    <div
      className="flex-col align-left justify-start g-1 p-1 radius-10 back-white"
      style={{ width: "40rem" }}
    >
      <div className="w-full flex-row align-center justify-between">
        <Title>{formTitle}</Title>
        {!isModal && (
          <button
            type="button"
            className="blueActionBtnDark"
            style={{
              background:
                formType === "yearly"
                  ? "var(--blueColor1)"
                  : "var(--folderColor)",
            }}
            onClick={() => addNewDataFormik.current.handleSubmit()}
          >
            Save
          </button>
        )}
      </div>
      <Formik
        initialValues={
          isModal
            ? data
            : formType === "yearly"
            ? {
                enrollment: "",
                transactions: [
                  { name: "Tuitions", amount: "" },
                  { name: "Medical charges", amount: "" },
                  { name: "Restitution charges", amount: "" },
                  { name: "Software charges", amount: "" },
                ],
              }
            : {
                subscriptionType: "",
                transactions: [
                  { name: "Tuitions", amount: "" },
                  { name: "Medical charges", amount: "" },
                  { name: "Restitution charges", amount: "" },
                  { name: "Software charges", amount: "" },
                ],
              }
        }
        onSubmit={(values) => outputData(values)}
        enableReinitialize
        innerRef={addNewDataFormik}
      >
        {({ values, touched, errors, setFieldValue }) => {
          return (
            <Form className="w-full flex-col align-left justify-start g-2">
              <div className="w-full flex-col align-left justify-start g-1">
                <div className="w-full flex-row align-center justify-between g-1">
                  {formType.toLowerCase() === "monthly" ? (
                    <div className="flex w-half">
                      <DropDownInput
                        name="subscriptionType"
                        label="Subscribe type"
                        placeholder="Choose type"
                        touched={touched}
                        errors={errors}
                        value={values.subscriptionType}
                        suggestionList={["Monthly", "Semester"]}
                        setFieldValue={(val) =>
                          setFieldValue("subscriptionType", val)
                        }
                      />
                    </div>
                  ) : (
                    <FormInput
                      type="text"
                      name="enrollment"
                      label="Enrollment as"
                      placeholder="Enter yearly enrollment name"
                      touched={touched}
                      errors={errors}
                      containerClass={"w-half"}
                    />
                  )}
                  <div className="flex w-half">
                    <DropDownInput
                      multiple
                      name="classes"
                      label="Enrollment as"
                      placeholder="Enter yearly enrollment name"
                      touched={touched}
                      errors={errors}
                      value={values?.classes}
                      suggestionList={["1", "2", "3"]}
                      setFieldValue={(val) => setFieldValue("classes", val)}
                    />
                  </div>
                </div>
                <hr color="#E5E5E5" className="w-full" />
              </div>

              <div className="flex-col align-left jutify-start w-full g-1 ">
                <Title>Services</Title>
                <FieldArray name="transactions">
                  {({ push, remove }) => (
                    <>
                      {values?.transactions?.length > 0 &&
                        values?.transactions?.map((_, index) => (
                          <InputRowItem
                            key={index}
                            index={index}
                            remove={remove}
                            touched={touched}
                            errors={errors}
                          />
                        ))}

                      <button
                        type="button"
                        onClick={() => push({ name: "", amount: "" })}
                        className="ml-1 w-fit transparentBtn flex-row align-center jsutify-start g-05"
                      >
                        <img
                          src={
                            isModal
                              ? PlusIconGreen
                              : formType === "yearly"
                              ? PlusIconBlue
                              : PlusIconYellow
                          }
                          alt=""
                          fill="red"
                          style={{ width: "1.5rem", height: "1.5rem" }}
                        />
                        <span className="poppins t-14">
                          <b>Add new</b>
                        </span>
                      </button>
                    </>
                  )}
                </FieldArray>
                {isModal && (
                  <div className="flex-row align-center justify-center w-full pr-1 pl-2">
                    <button
                      type="submit"
                      className="actionBtn w-full"
                      // style={{
                      //   background:
                      //     formType.toLowerCase() === "monthly"
                      //       ? "var(--folderColor)"
                      //       : "var(--greenColor)",
                      //   border: `2px solid ${
                      //     formType.toLowerCase() === "monthly"
                      //       ? "var(--folderColor)"
                      //       : "var(--greenColor)"
                      //   }`,
                      // }}
                    >
                      Save changes
                    </button>
                  </div>
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default AddNewFee;
